<template>
   <v-card outlined :color="isSelected ? 'primary' : 'secondary'" :class="`mb-4 bg-info ${isSelected ? 'active' : ''}`" @click="click()">
    <v-list-item :class="`item-box ${isSelected ? 'active' : ''}`" three-line>
      <v-list-item-content class="pa-0">
        <v-list-item-title class="item-title">
          <span>{{ title }}</span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default {
  name: 'SubMenuCard',
  props: {
    title: [String],
    isSelected: [Boolean],
    itemKey: [String]
  },
  methods: {
    click() {
      this.$emit('click', this.itemKey)
    }
  }
}
</script>

<style lang="scss" scoped>
.item-title{
   text-align: center;
    color: white;
    font-weight: 500;
}

.item-box {
   min-height: 50px;
}

.active {
    box-shadow: 1px 1px 10px grey;
    text-decoration-color: white;
    border: 2px solid brown;
  }
</style>
